<!-- 组件说明 -->
<template>
  <div class="con">
    <div class="pro-box">
      <div class="goodsimg">
        <goodsimg
          :gooodsDetail="gooodsDetail"
          :goodsType="goodsType"
        ></goodsimg>
      </div>
      <div class="pro-right">
        <div class="pro-title">
          <h1>{{ gooodsDetail.name }}</h1>
        </div>

        <!-- <div class="tip" v-if="gooodsDetail.promotion">
          {{ gooodsDetail.promotion }}
        </div> -->
        <div
          class="sales"
          v-if="
            goodsType == 1 &&
            gooodsDetail.goodsActivityInfo.activityInfos.length
          "
        >
          <!-- && gooodsDetail.goodsActivityInfo.activity -->
          <div class="sale">促销优惠</div>
          <ul class="sale-ul">
            <!-- <li v-for="item in gooodsDetail.goodsActivityInfo.activityInfos"><span>{{item.badge}} | {{item.description}}</span></li> -->
            <li
              v-for="item in gooodsDetail.goodsActivityInfo.activityInfos"
              class="desc-item"
            >
              <span class="badge">{{ item.badge }}</span>
              <span class="description">{{ item.description }}</span>
            </li>
          </ul>
        </div>

        <goodschange
          :gooodsDetail="gooodsDetail"
          :goodsType="goodsType"
        ></goodschange>
        <!-- <div class="stock" v-if="goodsType == 1"  >
          <span>库存</span> 
          <span v-if="gooodsDetail.iszy&&gooodsDetail.stock >0">有货</span>
          <span v-if="!gooodsDetail.iszy&&gooodsDetail.stock >=200">≥200</span>
          <span v-if="!gooodsDetail.iszy&&gooodsDetail.stock<200&&gooodsDetail.stock">{{gooodsDetail.stock}}</span>
           <span v-if="!gooodsDetail.stock">缺货</span>
        </div> -->
        <!-- <div class="num" v-if="goodsType == 1 && gooodsDetail">
          <span> 数量</span>
          <inputnum
            :key="gooodsDetail.id"
            ref="inputNumber"
            :maxNumber="
              gooodsDetail.stock > gooodsDetail.goodsActivityInfo.limitedCount
                ? gooodsDetail.goodsActivityInfo.limitedCount
                : gooodsDetail.stock
            "
            :skuNum="gooodsDetail.zhxs ? gooodsDetail.zybz : ''"
            v-if="gooodsDetail.goodsActivityInfo.limited"
          ></inputnum>
          <inputnum
            :key="gooodsDetail.id"
            ref="inputNumber"
            :maxNumber="gooodsDetail.stock ? gooodsDetail.stock : null"
            :skuNum="gooodsDetail.zhxs ? gooodsDetail.zybz : ''"
            v-else
          ></inputnum>
        </div> -->
        <!-- <div class="num" v-if="goodsType == 2">
          <span> 数量</span>
          <inputnum ref="inputNumber"></inputnum>
        </div> -->
        <!-- <div
          v-if="gooodsDetail.isForbidAreaSale"
          class="tip"
          style="text-align: center"
        >
          此商品不支持在当前地区销售
        </div> -->
        <!-- <div
          class="btn-box"
          v-if="
            gooodsDetail.status &&
            gooodsDetail.stock != 0 &&
            !gooodsDetail.isForbidAreaSale
          "
        >
          <div class="pay c-pointer" @click="nowBuy(gooodsDetail)">
            立即购买
          </div>
          <div
            class="addCart c-pointer"
            @click="addCart(gooodsDetail, 1)"
            v-if="goodsType == 1"
          >
            <img
              :src="require('@/assets/images/icon_shopping-white.png')"
              alt=""
            />
            加入购物车
          </div>
          <div
            class="addCart c-pointer"
            @click="addCart(gooodsDetail, 2)"
            v-if="goodsType == 2"
          >
            <img
              :src="require('@/assets/images/icon_shopping-white.png')"
              alt=""
            />
            加入购物车
          </div>
        </div> -->
        <!-- <div
          class="btn-box"
          v-if="
            !gooodsDetail.status ||
            (gooodsDetail.stock == 0 && !gooodsDetail.isForbidAreaSale)
          "
        >
          <el-button v-if="!gooodsDetail.status" :disabled="true"
            >商品已下架</el-button
          >
          <el-button v-if="gooodsDetail.stock == 0" :disabled="true"
            >暂无库存</el-button
          >
        </div>
        <div class="btn-box">
          <div class="forbid" v-if="gooodsDetail.isForbidAreaSale">
            地区禁售
          </div>
        </div>
        <div class="serve">
          <ul>
            <li>服务承诺</li>
            <li>
              <img :src="require('@/assets/images/icon_goods.png')" alt="" />
              正品保障
            </li>
            <li>
              <img :src="require('@/assets/images/icon_goods.png')" alt="" />
              隐私配送
            </li>
            <li>
              <img :src="require('@/assets/images/icon_goods.png')" alt="" />
              货到付款/在线支付
            </li>
          </ul>
        </div> -->
      </div>
      <goodsrecommend
        :gooodsDetail="gooodsDetail"
        v-if="gooodsDetail && goodsType"
        :goodsType="goodsType"
      ></goodsrecommend>
      <success v-if="successShow">加购成功</success>
      <toast ref="toast"></toast>
      <popup
        class="popup-info"
        width="350px"
        height="200px"
        @close="close"
        v-if="show"
      >
        <div>
          <div class="header">
            <span>出错提示</span>
            <img
              class="close2"
              :src="require('@/assets/images/x.png')"
              alt=""
              @click="close"
            />
          </div>
          <div class="middle">
            <img
              class="errimg"
              :src="require('@/assets/images/t_s.png')"
              alt=""
            />
            <span>{{ message }}</span>
          </div>
        </div>
      </popup>
    </div>
  </div>
</template>

<script>
import goodsimg from "@/pages/main/detail/components/goods-img";
import inputnum from "@/components/input-number";
import goodschange from "@/pages/main/detail/components/goods-change";
import goodsrecommend from "@/pages/main/detail/components/goods-recommend";
export default {
  components: {
    goodschange,
    inputnum,
    goodsrecommend,
    goodsimg,
  },
  props: ["gooodsDetail", "goodsType"],
  data() {
    return {
      successShow: false,
      show: false,
      message: "",
    };
  },
  computed: {},
  methods: {
    addCart(gooodsDetail, type) {
      //console.log(gooodsDetail);
      if (!this.$store.state.hasLogin)
        return this.$router.push({ path: "/login" });
      let num = this.$refs.inputNumber.number;
      if (type == 1) {
        this.$api
          .POST_ADDCART({
            cartItemType: "goods", //单品加购
            id: gooodsDetail.id,
            quantity: num,
          })
          .then((res) => {
            if (res.status) {
              this.successShow = true;
              this.$store.commit(
                "GETCARTCOUNT",
                Number(this.$store.state.cartNum) + Number(num)
              );
              this.ANALYSISSAVE(gooodsDetail);
            } else {
              this.show = true;
              this.message = res.message;
            }
          });
      } else {
        this.$api
          .POST_ADDCART({
            cartItemType: "combination", //套餐加购
            id: gooodsDetail.id,
            quantity: num,
          })
          .then((res) => {
            if (res.status) {
              this.successShow = true;
              this.$store.commit(
                "GETCARTCOUNT",
                Number(this.$store.state.cartNum) + Number(num)
              );
            } else {
              this.show = true;
              this.message = res.message;
            }
          });
      }
    },
    success() {
      this.successShow = false;
    },
    close() {
      this.show = false;
    },
    nowBuy(data) {
      if (!this.$store.state.hasLogin)
        return this.$router.push({ path: "/login" });
      if (data.stock == 0) {
        this.$refs.toast.info = {
          title: "库存不足",
          type: "fail",
        };
        this.$refs.toast.isShow();
      } else {
        let type = this.$route.query.type;
        let quantity = this.$refs.inputNumber.number;
        let id = data.id;
        if (this.$store.state.hasLogin) {
          let info = {
            id,
            orderSubmitType: type
              ? type == 1
                ? "goods"
                : "combination"
              : "cart",
            quantity,
            cartItemIds: !type ? this.$route.query.cartItemIds : "",
            source: "web",
          };
          this.$api.POST_OREDERPRE(info).then((res) => {
            if (!res.status) {
              this.$refs.toast.info = {
                title: res.message,
                type: "fail",
              };
              this.$refs.toast.isShow();
              return;
            } else {
              this.$router.push({
                path: "/cart/verify",
                query: { type, quantity, id },
              });
            }
          });
        } else {
          this.$refs.toast.info = {
            title: "请先登录",
            type: "fail",
          };
          this.$refs.toast.isShow();
        }
      }
    },
    ANALYSISSAVE(gooodsDetail) {
      let domain = "http://www.dgsjyyy.com";
      let source = "web";
      let goodsId = gooodsDetail.id;
      let content = gooodsDetail.name;
      let keyword = this.$route.query.keyword;
      let goodsName = gooodsDetail.name;
      let title;
      let type;
      let url;
      title = "加入购物车";
      (type = "cart"),
        (url = `http://www.dgsjyyy.com/detail?goodsId=${gooodsDetail.id}&type=1`);
      this.$api
        .POST_ANALYSISSAVE({
          domain,
          source,
          title,
          type,
          url,
          content,
          goodsId,
          goodsName,
          keyword,
        })
        .then((res) => {
          //console.log(res);
        })
        .catch((err) => console.log(err));
    },
  },
  mounted() {
    //console.log(this.gooodsDetail);
  },
  created() {
    // this.gooodsDetail.isForbidAreaSale = true
  },
};
</script>

<style lang='scss' scoped>
.pro-box {
  display: flex;
  // height: 650px;
}
.pro-right {
  width: 512px;
  margin-left: 48px;
  flex-shrink: 0;
  .pro-title {
    margin-bottom: 38px;
    display: flex;
    flex-direction: column;
    i {
      display: inline-block;
      // width: 40px;
      padding: 0 6px;
      height: 20px;
      border: 1px solid #fa4b4b;
      font-size: 12px;
      color: #fa4b4b;
      font-weight: 400;
      text-align: center;
      line-height: 19px;
      margin-right: 5px;
      border-radius: 3px;
    }
    h1 {
      font-size: 18px;
    }
  }
  .forbidInfo {
    height: 25px;
    background: #f8b737;
    color: #ffffff;
    line-height: 25px;
    text-align: center;
    margin-top: 10px;
  }
  .price {
    margin-bottom: 22px;
    .span1 {
      font-size: 14px;
      color: #808080;
    }

    .span2 {
      color: #fa4b4b;
      font-size: 36px;
      font-weight: bold;
      span {
        font-size: 20px;
      }
    }
    .span3 {
      font-size: 16px;
      color: #999999;
      text-decoration: line-through;
    }
  }
  .tip {
    // width: 100%;
    //height: 44px;
    background-color: #fff6f6;
    font-size: 12px;
    color: #ff5151;
    border-radius: 2px;
    line-height: 14px;
    padding: 10px;
    margin: -18px 0 26px 0;
  }
}
.stock,
.num {
  font-size: 13px;
  color: #505050;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  span {
    display: inline-block;
    width: 60px;
    text-align-last: justify;
    margin-right: 20px;
    font-size: 14px;
    color: #808080;
  }
}
.num {
  font-size: 13px;
  color: #505050;
  display: flex;
  .changenum {
    display: flex;
    .add,
    .sub {
      height: 28px;
      width: 28px;
      border: 1px solid #e0e0e0;
    }
    input {
      width: 60px;
      border: 1px solid #e0e0e0;
    }
  }
}
.btn-box {
  display: flex;
  margin: 38px 0 34px 0;
  .pay,
  .addCart {
    width: 160px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 16px;
    border-radius: 2px;
  }
  .pay {
    background-color: #fff2f2;
    color: #fa4b4b;
    border: 1px solid #fa4b4b;
    margin-right: 20px;
  }
  .addCart {
    background-color: #fa4b4b;
    color: #ffffff;
    img {
      vertical-align: middle;
      margin-right: 8px;
      padding-bottom: 3px;
    }
  }
}
.serve {
  font-size: 12px;
  color: #999999;

  ul {
    display: flex;
    li {
      margin-right: 18px;
      @include flex-c;
      img {
        margin-right: 6px;
      }
    }
  }
}
.goodsimg {
  width: 410px;
  flex-shrink: 0;
}
.nostock {
  width: 160px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 16px;
  border-radius: 2px;
  border: 1px solid #f2f2f2;
  color: #505050;
  background-color: #f2f2f2;
}
.header {
  height: 44px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f8f8f8;
  span {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
    margin-left: 17px;
  }
  .close2 {
    width: 15px;
    height: 15px;
    position: absolute;
    right: 20px;
    cursor: pointer;
  }
}
.middle {
  align-items: center;
  @include flex-d-c;
  img {
    width: 104px;
    height: 83px;
    margin: 12px 0;
  }
  span {
    font-size: 16px;
    color: #333333;
    padding: 0 30px;
    text-align: center;
  }
}
.sales {
  display: flex;
  .sale {
    text-align-last: justify;
    margin-right: 20px;
    font-size: 14px;
    color: #808080;
    line-height: 19px;
  }

  .sale-ul {
    width: 400px;

    .desc-item {
      display: flex;
      // align-items: center;
      margin-bottom: 8px;
      .badge {
        padding: 0 6px;
        height: 20px;
        line-height: 19px;
        white-space: nowrap;
        border: 1px solid #fa4b4b;
        font-size: 12px;
        color: #fa4b4b;
        font-weight: 400;
        text-align: center;
        margin-right: 8px;
        border-radius: 3px;
        display: inline-block;
      }
      .description {
        color: #fa4b4b;
        font-size: 13px;
        line-height: 16px;
        display: flex;
        align-items: center;
      }
    }
  }
}
.forbid {
  background: #d8d8d8;
  color: #a0a0a0;
  width: 160px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 16px;
  border-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/pages/main/detail/components/goods-product.vue